<template>
  <div class="inventory__container">
    <div class="inventory__title">
      Inventory
    </div>
    <div class="inventory__subtitle">
      All files are completed upon post-decontamination entry into this facility. All Records are
      made public.
    </div>

    <div class="flex flex-wrap">
      <div
        v-for="(products, category) in inventoryByCategory"
        :key="category"
        class="inventory__table"
      >
        <div class="inventory__table-header">
          <div class="w-2/3">
            {{ category }}
          </div>
          <div class="w-1/3">
            Units
          </div>
        </div>
        <div
          v-for="(product, index) in products"
          :key="index"
          class="inventory__table-row"
        >
          <div class="w-2/3 border-l">
            {{ product.product }}
          </div>
          <div class="w-1/3 bg-blue uppercase">
            {{ product.units }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import inventory from '@/services/inventory'

export default {
  name: 'RationsInventory',

  data() {
    return {
      inventory,
    }
  },

  computed: {
    inventoryByCategory() {
      return this.inventory.reduce((r, a) => {
        r[a.category] = r[a.category] || []
        r[a.category].push(a)
        return r
      }, {})
    },
  },
}
</script>

<style lang="postcss" scoped>
select {
  -webkit-appearance: none;
  height: 34px;
  width: 181px;
  background: url('../../assets/select-arrow.png') no-repeat;
  background-position: calc(100% - 4px) 50%;
  @apply bg-blue-darkest text-blue-light border-2 border-blue-light p-2 rounded-none;

  &:focus {
    outline: 0;
  }
}
.inventory {
  &__container {
    @apply text-blue-light p-4;
  }

  &__title {
    font-family: 'univia-pro';
    font-size: 40px;
    @apply mb-4 uppercase;
  }

  &__subtitle {
    font-family: 'proxima-nova';
    font-size: 20px;
    font-weight: 500;
    @apply mb-4 pb-2 border-b border-blue-light;
  }

  &__table {
    @apply my-4 w-full;

    &-header {
      font-family: 'univia-pro';
      font-size: 20px;
      font-weight: 900;
      @apply flex bg-blue-light text-blue-darkest uppercase;

      & > div {
        @apply p-2;
      }
    }

    &-row {
      font-family: 'proxima-nova';
      font-size: 20px;
      font-weight: 500;
      @apply flex bg-blue-darkest text-blue-lighter;

      & > div {
        @apply border-b border-r border-blue-lighter p-2;
      }
    }
  }
}

@screen sm {
  .inventory {
    &__table {
      width: 375px;
      @apply mr-16;
    }
  }
}
</style>
